<fun-spinner *ngIf="loading"></fun-spinner>
<div *ngIf="!loading">
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-4 !p-8">
      <p *ngIf="userPositionItem" class="font-sans text-m text-eggplant-80">
        {{ 'OVERVIEW_QUEUE.SUMMARY' | translate:{ position: userPositionItem.id, amount: (moneyAhead | localeNumber) }
        }}
      </p>
      <p *ngIf="!userPositionItem" class="font-sans text-m text-eggplant-80">
        {{ 'OVERVIEW_QUEUE.NOT_FOUND' | translate }}
      </p>
    </div>

    <div *ngIf="listOpen" class="flex flex-col gap-4 max-h-[320px] overflow-y-auto">
      <div class="grid grid-cols-2 gap-6 !px-6 !py-4 bg-gray-10/[0.4] rounded-lg border border-gray-10">
        <span class="font-sans text-s text-eggplant-80">{{ 'OVERVIEW_QUEUE.HEADER_POSITION' | translate }}</span>
        <span class="font-sans text-s text-eggplant-80 text-right">{{ 'OVERVIEW_QUEUE.HEADER_AMOUNT' | translate
          }}</span>
      </div>
      <div class="flex flex-col gap-2">
        <div *ngFor="let item of sortedPositions"
          class="grid grid-cols-2 gap-6 items-center !px-12 !py-4 rounded-lg border"
          [ngClass]="item?.fromUser ? 'bg-[#E6F4ED] border-[#039755]' : 'bg-white/[0.6] border-gray-10'">
          <div class="flex items-center gap-4">
            <span class="font-sans text-m text-eggplant-80">#{{ item?.id }}</span>
            <span *ngIf="item?.fromUser"
              class="font-sans text-xs uppercase tracking-wider !px-3 !py-2 rounded-full bg-[#039755]/[0.1] text-[#039755]">
              {{ 'OVERVIEW_QUEUE.ROW_YOUR_RESERVATION' | translate }}
            </span>
          </div>
          <span class="font-sans text-m text-eggplant-80 text-right">{{ item?.amount | localeNumber }} €</span>
        </div>
        <p *ngIf="!sortedPositions.length" class="font-sans text-s text-eggplant-80 !px-6 !py-4">
          {{ 'OVERVIEW_QUEUE.EMPTY' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>